import { tagsFromArray } from './tags';
import { getTagError } from './validations/tags';
import { getSize } from './iterable/getSize';
import { convert } from './product/convert';

import { MAX_NUMBER_OF_TAGS } from '../constants/validations';
import { EMPTY } from '../constants';
import { ETSY } from '../constants/channels';
import ATTRIBUTE from '../constants/attributes';

export function shapeAIResponseForApp({ attribute, channel, response }) {
  function filterTags(tag) {
    return !getTagError({ channel, tag });
  }

  switch (attribute) {
    case ATTRIBUTE.DESCRIPTION: {
      return response.text
        ? convert({ from: ETSY, to: channel, type: attribute, value: response.text })
        : '';
    }

    case ATTRIBUTE.TAGS: {
      if (!Array.isArray(response.text) || getSize(response.text) === 0) return EMPTY.ORDERED_MAP;

      return tagsFromArray(response.text.filter(filterTags).slice(0, MAX_NUMBER_OF_TAGS[channel]));
    }

    default: {
      return response.text || '';
    }
  }
}
